import { useCallback, useEffect, useState } from 'react';

/// <summary>
/// Tiny localStorage-backed useState. Reads on mount, writes on change,
/// JSON-encoded. Silent on quota / availability errors (private mode).
/// </summary>
export function useLocalStorage<T>(key: string, initial: T): [T, (value: T) => void] {
  const read = useCallback((): T => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw === null ? initial : (JSON.parse(raw) as T);
    } catch {
      return initial;
    }
  }, [key, initial]);

  const [value, setValue] = useState<T>(read);

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // quota or unavailable — ignore
    }
  }, [key, value]);

  return [value, setValue];
}
